module.exports = __webpack_public_path__ + "static/Cancer1-113b0264ec3280c7e2c356d20387e382.jpeg";